const session_expired = {
    title: '会话已过期',
    subtitle: '会话可能已过期，你已被退出登录。请点击下方按钮重新登录到管理控制台。',
    button: '重新登录',
};
export default Object.freeze(session_expired);
